import { CircularProgress } from '@mui/material';
import Inscricao from 'entity/Inscricao';
import React, { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom';
import {
    Box, Typography, Card, CardContent, Container, Paper, Stack, Divider
} from '@mui/material';
import { 
    Business as BusinessIcon,
    Person as PersonIcon,
    Email as EmailIcon,
    Phone as PhoneIcon,
    LocationOn as LocationIcon,
    Event as EventIcon,
    QrCode as QrCodeIcon,
    Description as DescriptionIcon
} from '@mui/icons-material';
import { format } from 'date-fns';
import ImageBox from 'components/basic/ImageBox';
import Rodada from 'entity/Rodada';

import { QRCodeCanvas } from 'qrcode.react';
import AcoesDoInscrito from './AcoesDoInscrito';
import PainelReunioes from './PainelReunioes';

const formatDate = (dateStr) => format(new Date(dateStr), "dd/MM, HH:mm");

const parseDescription = (text) => {
    // Regex global para links HTTP/HTTPS
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);

    return parts.map((part, idx) => {
        if (urlRegex.test(part)) {
            return (
                <Link
                    key={idx}
                    href={part}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                    sx={{ wordBreak: 'break-word' }}
                >
                    {part}
                </Link>
            );
        }
        return <span key={idx}>{part}</span>;
    });
};

export default function PainelDoInscrito() {
    const [rodadaFull, setRodadaFull] = useState(null)
    const [inscrito, setInscrito] = useState(null)
    const [searchParams] = useSearchParams();
    const searchUid = searchParams.get("uid");
    const uidRodada = inscrito?.rodada.uid
    let podeExibirReunioes = false;
    const { exibeAgenda } = rodadaFull?.painelInscrito || {};


    podeExibirReunioes = exibeAgenda === "SIM";



    useEffect(() => {
        if (searchUid) {
            return Inscricao.onSnapshot(searchUid, (obj) => {
                setInscrito(obj);
            })
        }
    }, [searchUid]);

    useEffect(() => {
        if (uidRodada) {
            return Rodada.onSnapshot(uidRodada, (obj) => {
                setRodadaFull(obj);
            })
        }
    }, [uidRodada]);    if (inscrito === undefined) {
        return (
            <Container maxWidth="lg" sx={{ py: 4 }}>
                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    minHeight: '60vh',
                    gap: 3
                }}>
                    <CircularProgress size={60} thickness={4} />
                    <Typography variant="h6" color="text.secondary">
                        Carregando dados...
                    </Typography>
                </Box>
            </Container>
        );
    }
    
    if (inscrito === null) {
        return (
            <Container maxWidth="lg" sx={{ py: 4 }}>
                <Paper
                    sx={{
                        p: 6,
                        textAlign: 'center',
                        borderRadius: 4,
                        background: 'linear-gradient(135deg, #ffefef 0%, #ffcccc 100%)',
                    }}
                >
                    <Typography variant="h4" color="error.main" fontWeight={600} gutterBottom>
                        Inscrição não encontrada
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Verifique se o link está correto ou entre em contato com o suporte.
                    </Typography>
                </Paper>
            </Container>
        );
    }const { empresa, rodada } = inscrito;
    const participante = empresa?.funcionarios;

    return (
        <Container maxWidth="lg" sx={{ py: { xs: 2, sm: 4 } }}>
            {/* Header com gradiente */}
            <Paper
                elevation={0}
                sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    p: { xs: 3, sm: 4 },
                    mb: 4,
                    borderRadius: 4,
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(255,255,255,0.1)',
                        backdropFilter: 'blur(10px)',
                    }
                }}
            >
                <Box sx={{ position: 'relative', zIndex: 1 }}>
                    <Typography 
                        variant="h3" 
                        fontWeight={700}
                        sx={{ 
                            fontSize: { xs: '1.8rem', sm: '2.5rem', md: '3rem' },
                            mb: 1,
                            textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                        }}
                    >
                        Painel do Inscrito
                    </Typography>
                    <Typography 
                        variant="h6" 
                        sx={{ 
                            opacity: 0.9,
                            fontSize: { xs: '1rem', sm: '1.25rem' }
                        }}
                    >
                        Bem-vindo, {participante?.nomeParticipante}
                    </Typography>
                </Box>
            </Paper>            {/* Dados da Rodada - Design Moderno */}
            {!rodadaFull ? (
                <Card 
                    sx={{ 
                        mb: 4, 
                        borderRadius: 3,
                        boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                        border: '1px solid rgba(255,255,255,0.2)'
                    }}
                >
                    <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <EventIcon sx={{ color: 'primary.main', fontSize: { xs: 24, sm: 28 } }} />
                            <Typography variant="h6" fontWeight={600}>
                                {rodada?.nome}
                            </Typography>
                        </Box>
                    </CardContent>
                </Card>
            ) : (
                <Card
                    sx={{
                        mb: 4,
                        borderRadius: 4,
                        boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
                        overflow: 'hidden',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        border: '1px solid rgba(255,255,255,0.2)',
                        '&:hover': {
                            transform: 'translateY(-4px)',
                            boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
                        },
                    }}
                >
                    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
                        {rodadaFull.capa && (
                            <Box
                                sx={{
                                    width: { xs: '100%', md: 350 },
                                    height: { xs: 200, md: 280 },
                                    position: 'relative',
                                    overflow: 'hidden',
                                    flexShrink: 0,
                                    '&::after': {
                                        content: '""',
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        background: 'linear-gradient(45deg, rgba(102,126,234,0.1), rgba(118,75,162,0.1))',
                                    }
                                }}
                            >                                <ImageBox
                                    src={rodadaFull.capa.base64}
                                    alt="Capa da rodada"
                                    maxWidth="100%"
                                    maxHeight="100%"
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        '& img': {
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            transition: 'transform 0.3s ease',
                                            '&:hover': {
                                                transform: 'scale(1.05)'
                                            }
                                        }
                                    }}
                                />
                            </Box>
                        )}
                        <CardContent
                            sx={{
                                p: { xs: 2, sm: 3, md: 4 },
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Box>
                                <Typography
                                    variant="h4"
                                    fontWeight={700}
                                    gutterBottom
                                    sx={{ 
                                        fontSize: { xs: '1.5rem', sm: '2rem', md: '2.25rem' },
                                        color: 'primary.main',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}
                                >
                                    {rodadaFull.nome}
                                </Typography>
                                
                                <Stack spacing={2} sx={{ mb: 3 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                        <LocationIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
                                        <Typography 
                                            color="text.secondary" 
                                            sx={{ 
                                                fontSize: { xs: '0.9rem', sm: '1rem' },
                                                textTransform: 'uppercase',
                                                fontWeight: 500
                                            }}
                                        >
                                            {rodadaFull.local}
                                        </Typography>
                                    </Box>
                                    
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                        <EventIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
                                        <Typography 
                                            color="text.secondary"
                                            sx={{ fontSize: { xs: '0.9rem', sm: '1rem' } }}
                                        >
                                            {`${formatDate(rodadaFull.dataInicio)} até ${formatDate(rodadaFull.dataFinal)}`}
                                        </Typography>
                                    </Box>
                                </Stack>
                                
                                {rodadaFull.descricao && (
                                    <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
                                        <DescriptionIcon sx={{ color: 'text.secondary', fontSize: 20, mt: 0.5 }} />
                                        <Typography 
                                            variant="body1" 
                                            sx={{ 
                                                lineHeight: 1.6,
                                                color: 'text.primary',
                                                fontSize: { xs: '0.9rem', sm: '1rem' }
                                            }}
                                        >
                                            {parseDescription(rodadaFull.descricao)}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </CardContent>
                    </Box>
                </Card>
            )}            {/* Dados do Participante e Empresa - Design Moderno */}
            <Card
                sx={{
                    mb: 4,
                    borderRadius: 4,
                    boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
                    overflow: 'hidden',
                    border: '1px solid rgba(255,255,255,0.2)',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: '0 16px 50px rgba(0,0,0,0.2)',
                    },
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' } }}>
                    <CardContent sx={{ flex: 1, p: { xs: 2, sm: 3, md: 4 } }}>
                        {/* Seção Participante */}
                        <Box sx={{ mb: 4 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>                                <PersonIcon sx={{ 
                                    fontSize: { xs: 28, sm: 32 },
                                    p: 1,
                                    bgcolor: 'primary.main',
                                    borderRadius: '50%',
                                    color: 'white'
                                }} />
                                <Typography 
                                    variant="h5" 
                                    fontWeight={700}
                                    sx={{ 
                                        color: 'primary.main',
                                        fontSize: { xs: '1.25rem', sm: '1.5rem' }
                                    }}
                                >
                                    Participante
                                </Typography>
                            </Box>
                            
                            <Stack spacing={2}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <PersonIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
                                    <Box>
                                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
                                            Nome
                                        </Typography>
                                        <Typography 
                                            variant="body1" 
                                            fontWeight={600}
                                            sx={{ fontSize: { xs: '0.9rem', sm: '1rem' } }}
                                        >
                                            {participante?.nomeParticipante}
                                        </Typography>
                                    </Box>
                                </Box>
                                
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <EmailIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
                                    <Box>
                                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
                                            Email
                                        </Typography>
                                        <Typography 
                                            variant="body1"
                                            sx={{ 
                                                fontSize: { xs: '0.9rem', sm: '1rem' },
                                                wordBreak: 'break-word'
                                            }}
                                        >
                                            {participante?.email}
                                        </Typography>
                                    </Box>
                                </Box>
                                
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <PhoneIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
                                    <Box>
                                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
                                            Celular
                                        </Typography>
                                        <Typography 
                                            variant="body1"
                                            sx={{ fontSize: { xs: '0.9rem', sm: '1rem' } }}
                                        >
                                            {participante?.celular}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Stack>
                        </Box>

                        <Divider sx={{ my: 3 }} />

                        {/* Seção Empresa */}
                        <Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                                <BusinessIcon sx={{ 
                                    fontSize: { xs: 28, sm: 32 },
                                    p: 1,
                                    bgcolor: 'secondary.main',
                                    borderRadius: '50%',
                                    color: 'white'
                                }} />
                                <Typography 
                                    variant="h5" 
                                    fontWeight={700}
                                    sx={{ 
                                        color: 'secondary.main',
                                        fontSize: { xs: '1.25rem', sm: '1.5rem' }
                                    }}
                                >
                                    Empresa
                                </Typography>
                            </Box>
                            
                            <Stack spacing={2}>
                                <Box>
                                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
                                        Nome Fantasia
                                    </Typography>
                                    <Typography 
                                        variant="body1" 
                                        fontWeight={600}
                                        sx={{ fontSize: { xs: '0.9rem', sm: '1rem' } }}
                                    >
                                        {empresa?.nomeFantasia}
                                    </Typography>
                                </Box>
                                
                                <Box>
                                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
                                        Razão Social
                                    </Typography>
                                    <Typography 
                                        variant="body1"
                                        sx={{ fontSize: { xs: '0.9rem', sm: '1rem' } }}
                                    >
                                        {empresa?.razaoSocial}
                                    </Typography>
                                </Box>
                                
                                <Box>
                                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
                                        CNPJ
                                    </Typography>
                                    <Typography 
                                        variant="body1"
                                        sx={{ fontSize: { xs: '0.9rem', sm: '1rem' } }}
                                    >
                                        {empresa?.cnpj}
                                    </Typography>
                                </Box>
                                
                                {empresa?.descricaoEmpresa && (
                                    <Box>
                                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
                                            Descrição
                                        </Typography>
                                        <Typography 
                                            variant="body1"
                                            sx={{ 
                                                fontSize: { xs: '0.9rem', sm: '1rem' },
                                                lineHeight: 1.6,
                                                mt: 0.5
                                            }}
                                        >
                                            {empresa?.descricaoEmpresa}
                                        </Typography>
                                    </Box>
                                )}
                            </Stack>
                        </Box>
                    </CardContent>
                    
                    {/* QR Code Section */}
                    <Box sx={{
                        width: { xs: '100%', lg: 350 },
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: { xs: 3, sm: 4 },
                        bgcolor: 'grey.50',
                        borderLeft: { lg: '1px solid rgba(0,0,0,0.1)' },
                        borderTop: { xs: '1px solid rgba(0,0,0,0.1)', lg: 'none' }
                    }}>
                        <Box sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 1, 
                            mb: 2 
                        }}>
                            <QrCodeIcon sx={{ color: 'primary.main', fontSize: 24 }} />
                            <Typography 
                                variant="subtitle1" 
                                fontWeight={600}
                                color="primary.main"
                                sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }}
                            >
                                QR Code
                            </Typography>
                        </Box>
                        <Typography 
                            variant="body2" 
                            color="text.secondary" 
                            textAlign="center"
                            sx={{ mb: 3, fontSize: { xs: '0.8rem', sm: '0.9rem' } }}
                        >
                            QR Code para esta página
                        </Typography>
                        <Box
                            sx={{
                                p: 2,
                                bgcolor: 'white',
                                borderRadius: 3,
                                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                            }}
                        >
                            <QRCodeCanvas
                                value={Inscricao.getUrlPainelInscrito(inscrito?.uid)}
                                size={200}
                                bgColor="#ffffff"
                                fgColor="#000000"
                                level="H"
                                includeMargin
                            />
                        </Box>
                    </Box>
                </Box>
            </Card>
            {podeExibirReunioes && <PainelReunioes rodada={rodadaFull} inscrito={inscrito} />}            {/* Ações */}
            <AcoesDoInscrito rodada={rodadaFull} inscrito={inscrito} />
        </Container>
    );
}
